<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BJzDxb/tc-custom/9781488018756.jpg?1726483235790" alt="This image is the cover for the book Alaskan Christmas, Alaskan Grooms"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Alaskan Christmas, Alaskan Grooms
      </h1>
      <p class="bookDescription body article font2">
        <b>Now a Harlequin Movie, <i>Love Alaska</i>!<br/><br/>Her Christmas Match</b><br/><br/>After inheriting a gift shop in Love, Alaska, single mom Maggie Richards is ready for a new beginning—while her little boy is ready for a new daddy! But Maggie has no time for love—she wants to open the shop in time for Christmas, something she’ll do with help from childhood friend Finn O’Rourke. Finn’s on board to help Maggie—but not with the romance rumors that swirl around them like snow. Like Maggie, he’s hiding too many secrets to ever wed. So why do Maggie and her little boy make him dream of finding an unusual gift under the tree—a ready-made family?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Belle Calhoune
      </h2>
      
      <p class="authorDescription body article">Belle Calhoune lives in Connecticut with her college sweetheart husband and two daughters. After a thirteen year career as a Federal Investigator, she chose to pursue a&#160; writing career.&#160; An avid lover of romance novels since she was a teen, she enjoys writing love stories and reading them. She loves spending summers in beautiful Cape Cod and traveling to new places. A dog lover, she has a mini poodle and a black lab. More than anything, she believes in happily ever afters.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5f40cf8e